/* eslint-disable no-useless-escape */

/**
 * Create a deep copy of an object
 * @param {Object} obj
 * @returns {Object}
 */
export function deepCopyObject(obj) {
    return JSON.parse(JSON.stringify(obj));
}


/**
 * Format number into a compact form, like "1.2K"
 * @param {Number} count
 * @returns {String}
 */
export function formatCount(count) {
    if (count < 1000) {
        return count;
    }

    if (count >= 1000 && count < 1000000) {
        return (Math.floor((count * 10) / 1000) / 10) + 'K';
    }

    return (Math.floor((count * 10) / 1000000) / 10) + 'M';
}

/**
 * Validate if user complete onboarding details
 * @param {Object} user
 * @returns {Boolean}
 */
export function hasCompletedOnboarding(user) {
    return !!user.first_name && !!user.last_name;
}

/**
 * Validate email address
 * @param {String} email
 * @returns {Boolean}
 */
export function validateEmail(email) {
    const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

    return re.test(email);
}


/**
 * Sanitize/format date string so that it is valid in Safari
 * @param {String} dateString
 * @returns {Strinh}
 */
export function sanitizeDateString(dateString) {
    return dateString.replace(/-/g, '/');
}

/**
 * Get date object from string
 * @param {String} dateString
 * @returns {Date}
 */
export function getDate(dateString) {
    return new Date(dateString.replace(/-/g, '/'));
}

/**
 * Capitalize a string
 * @param {String} str
 * @returns {String}
 */
export function capitalize(str) {
    return str.replace(/\w\S*/g, (txt) => txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase());
}


/**
 * replace the input uri's domain with the main domain
 * NOTE: For now this only works for production!
 * @param {String} uri
 * @returns {String}
 */
export function convertVideoUri(uri) {
    // This was used on old infrastructure which utilized cloudfront, to mask s3 urls with domain urls
    return uri;
}

/**
 * Get array of hashtags from string of hashtags
 * @param {String} hashtags - string in the form '#tag1 #tag2 #tag3'
 * @returns {Array}
 */
export function getHashtagsList(hashtags) {
    if (!hashtags) {
        return [];
    }

    return hashtags.split(' ').map((tag) => tag.replace('#', ''));
}

/**
 * check if survey is finalized
 * @param {Object} survey
 * @returns {Boolean}
 */
export function isSurveyCompleted(survey) {
    return survey.survey_questions.length
        && survey.report_intro
        && survey.report_intro.length
        && survey.email_template
        && survey.email_template.length
        && survey.email_template.includes('{{surveyLink}}')
        && survey.introduction
        && survey.introduction.length;
}


/**
 * Save login token
 * @param {String} loginToken
 */
export function saveLoginToken(loginToken) {
    localStorage.setItem('loginTokenStorageItem', loginToken);
}


/**
 * Delete login token
 */
export function deleteLoginToken() {
    localStorage.removeItem('loginTokenStorageItem');
}


/**
 * Sets the the authorization token for api requests
 */
export function setApiRequestToken() {
    window.AuthToken = localStorage.getItem('loginTokenStorageItem');

    if (window.AuthToken) {
        window._axios.interceptors.request.use((config) => {
            config.headers.Authorization = `Bearer ${window.AuthToken}`;

            return config;
        });
    }
}

/**
 * Clean content to send in email
 * @param {String} content
 * @param {String} selector
 * @returns {String}
 */
export function prepareContentForEmail(content, selector = null) {
    let value = content.replace(/&nbsp;/g, ' ');
    const el = document.createElement('div');

    el.innerHTML = value;

    const list = Array.from(el.querySelectorAll(selector || 'blockquote, h1, h2, h3, h4, h5, h6, ol, p, pre, ul, ol, table, td'));

    if (list.length > 0) {
        list.forEach((el) => {
            if (selector) {
                el.style.paddingLeft = '3em';
            }
            else {
                if (el.innerText !== ' ') {
                    el.style.margin = '0';
                    el.style.padding = '0';
                    el.style.lineHeight = '1.42';
                }

                if (el.className.includes('align-center')) {
                    el.style.textAlign = 'center';
                }

                if (el.className.includes('align-right')) {
                    el.style.textAlign = 'right';
                }

                if (el.tagName === 'OL' || el.tagName === 'UL') {
                    el.style.paddingLeft = '3em';
                }

                if (el.tagName === 'TD' || el.tagName === 'TABLE') {
                    el.style.width = '';
                }
            }
        });
    }

    return el.innerHTML;
}

/**
 * Sort array by key
 * @param {Array} arr
 * @param {String} key
 * @returns {Array}
 */
export function sortByKey(arr, key) {
    return arr.sort((a, b) => {
        const x = a[key].toLowerCase(),
            y = b[key].toLowerCase();

        if (x < y) {
            return -1;
        }
        else if (x > y) {
            return 1;
        }

        return 0;
    });
}



// WEBPACK FOOTER //
// ./src/utils/helpers.js